module.exports = __webpack_public_path__ + "media/assets/img/flags/uz-UZ-3a3fdab83e8f6ca8ea934d03219650fd.png";